import store_examen from '@/store/mods/clinique/examens'
import $ from 'jquery'

export default {
    name: 'l-examen',
    components: {},
    props: [],
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
            is_loading: true,
            is_empty: false,
            is_load_error: false,
            types_examens: [],    
        }
    },

    computed: {

    },

    mounted() {
        this.fetchExamens();
    },

    methods: {
        fetchExamens() {
            this.is_loading = true;
            this.is_load_error = false;
            store_examen.getExamens().then((response) => {
                this.types_examens = response

                if (this.types_examens.length === 0) {
                    this.is_empty = true;
                } else {
                    this.is_empty = false;
                }

                this.is_loading = false;
            }).catch(() => {
                this.is_loading = false;
                this.is_load_error = true
            });
        },

        toutSelectionner() {
            let is_checked = $('#examen-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.types_examens.forEach((type_examen) => {
                    this.one_is_checked.push({id: type_examen.id, libelle: type_examen.nom})
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },
    }
}